import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import useResponsive from 'utils/responsive';
import useProductWithVideo from 'utils/product-video';
import ProductGalleryQuickView from './product-gallery-quickview';
import ProductGalleryLookOverlay from './product-gallery-look-overlay';
import ProductGalleryMobile from './product-gallery-mobile';
import ProductGalleryDesktop from './product-gallery-desktop';

const ProductGallery = ({
  isQuickView = false,
  isLookOverlay = false,
  ...props
}) => {
  const { isMobile } = useResponsive();
  const product = useProductWithVideo(props.currentProduct, true);

  if (isQuickView) {
    return useMemo(
      () => <ProductGalleryQuickView {...props} currentProduct={product} />,
      [product],
    );
  }

  if (isLookOverlay) {
    return useMemo(
      () => <ProductGalleryLookOverlay {...props} />,
      [props.currentProduct],
    );
  }

  if (!isMobile) {
    return useMemo(
      () => <ProductGalleryDesktop {...props} currentProduct={product} />,
      [product, isMobile],
    );
  }

  return useMemo(
    () => <ProductGalleryMobile {...props} currentProduct={product} />,
    [product, isMobile],
  );
};

export default ProductGallery;
